import React, { useEffect } from 'react'
import { Dispatch } from 'redux'
import { PhotoLibraryOutlined, AddBoxOutlined } from '@material-ui/icons'
import { Main, Scrollable, SettingFormsWrapper } from '../../layouts'
import CreateMediaTypeGroupForm from '../../forms/CreateMediaTypeGroupForm'
import {
  CombinedTitle,
  TabsHead,
  View,
  SettingsMenu,
  Spinner,
} from '../../components'
import { AllMediaTypeGroupsTab } from './AllMediaTypeGroupsTab'
import { IMediaTypeGroups } from '../../types/mediaTypeGroups'
import { getMediaTypeGroups } from '../../actions/mediaTypesGroups'

export interface IMediaTypeGroupsPage {
  mediaTypeGroups: IMediaTypeGroups
  canAddMediaTypeGroup: boolean
  dispatch: Dispatch
}

export const MediaTypeGroupsPage = ({
  mediaTypeGroups,
  canAddMediaTypeGroup,
  dispatch,
}: IMediaTypeGroupsPage) => {
  useEffect(() => {
    dispatch(getMediaTypeGroups())
  }, [dispatch])
  return (
    <Main
      sidebarSecondary={<SettingsMenu />}
      titleBlock={
        <>
          <CombinedTitle first="Media Type Groups" second="Management" />
          <TabsHead
            tabs={[
              {
                label: 'All groups',
                value: 'all-groups',
                icon: <PhotoLibraryOutlined />,
              },
              ...(canAddMediaTypeGroup
                ? [
                    {
                      label: 'Add group',
                      value: 'add-group',
                      icon: <AddBoxOutlined />,
                    },
                  ]
                : []),
            ]}
          />
        </>
      }
      helmet="Administration: Media Type Groups"
    >
      <View tab="all-groups">
        {mediaTypeGroups.isLoading ? (
          <Spinner />
        ) : (
          <Scrollable>
            <AllMediaTypeGroupsTab
              dispatch={dispatch}
              mediaTypeGroupsList={mediaTypeGroups.list}
            />
          </Scrollable>
        )}
      </View>
      {canAddMediaTypeGroup && (
        <View keep tab="add-group">
          <Scrollable>
            <SettingFormsWrapper>
              <CreateMediaTypeGroupForm />
            </SettingFormsWrapper>
          </Scrollable>
        </View>
      )}
    </Main>
  )
}
